export default class Fanout {
    constructor() {}

    setUrl(newUrl) {
        this.url = newUrl
    };
    $get() {
        return {
            client: new Faye.Client(this.url)
        }
    }
}